import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { useDragLayer } from 'react-dnd';

import useStyles from './style';

const CustomDragLayer: FC = () => {
  const classes = useStyles();

  const { item, isDragging, clientOffset } = useDragLayer(monitor => ({
    item: monitor.getItem(),
    isDragging: monitor.isDragging(),
    clientOffset: monitor.getClientOffset(),
  }));

  useEffect(() => {
    document.body?.setAttribute('drag-active', `${isDragging}`);
  }, [isDragging]);

  if (!isDragging || !clientOffset || !!item.dataTransfer) {
    return null;
  }

  const { x, y } = clientOffset;

  return (
    <div
      className={classNames(classes.dragLabel)}
      style={{
        transform: `translate(${x + 10}px, ${y + 10}px)`,
      }}
    >
      {item.text}
    </div>
  );
};

export default CustomDragLayer;
